function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 25
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 25,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3301 6764)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3288.292 -6761.158)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.118,16.848a.4.4,0,0,1-.171-.057.349.349,0,0,1-.114-.456l.285.142-.285-.171a.709.709,0,0,0,.028-.712.781.781,0,0,0-.6-.427,2.238,2.238,0,0,1-1.795-1,.636.636,0,0,0-.484.313c-.142.256.028.655.085.8a.338.338,0,0,1-.6.313,1.688,1.688,0,0,1-.085-1.4,1.443,1.443,0,0,1,1.2-.712.309.309,0,0,1,.342.2,1.594,1.594,0,0,0,1.4.826,1.436,1.436,0,0,1,1.111.769,1.325,1.325,0,0,1-.057,1.339v.028A.264.264,0,0,1,37.118,16.848Z",
  transform: "translate(-33.261 -13.481)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3287.251 -6762)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.319,13.4a.424.424,0,0,1-.256-.114,8.769,8.769,0,0,0-1.994-1.852,1.187,1.187,0,0,0-.94-.171,4.623,4.623,0,0,1-2.051-.057.494.494,0,0,0-.4.085.349.349,0,0,0-.114.37l-.627.171v-.057a1.026,1.026,0,0,1,.313-.969,1.039,1.039,0,0,1,1.026-.228,3.689,3.689,0,0,0,1.738.057,1.923,1.923,0,0,1,1.424.285,8.292,8.292,0,0,1,2.137,1.994.321.321,0,0,1-.057.456A.485.485,0,0,1,43.319,13.4Z",
  transform: "translate(-36.913 -10.526)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3292.573 -6759.739)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.564,32.944a.4.4,0,0,1-.285-.142.356.356,0,0,1,.085-.456l4.644-3.02.028-.028a7.445,7.445,0,0,1,2.365-.627l2.82-.285.684-.342a27.091,27.091,0,0,0,4.672-2.877.993.993,0,0,0-.456-1,.365.365,0,0,1-.142-.427.85.85,0,0,0-.2-1.14.371.371,0,0,1-.142-.37,1,1,0,0,0-.427-1.282.248.248,0,0,1-.171-.228.351.351,0,0,1,.057-.285l.028-.028a.732.732,0,0,0,.085-.684.767.767,0,0,0-.541-.484l-.655-.057a2.748,2.748,0,0,0-.969-.028l-3.5.541a.33.33,0,0,1-.085-.655l3.5-.541a3.38,3.38,0,0,1,1.2.028l.627.142a1.456,1.456,0,0,1,1.026.883,1.415,1.415,0,0,1,0,1.026,1.687,1.687,0,0,1,.541,1.652,1.461,1.461,0,0,1,.37,1.567,1.634,1.634,0,0,1,.513,1.652c-.028.057-.057.142-.114.171a27.752,27.752,0,0,1-4.872,3.02l-.741.342a.171.171,0,0,1-.114.028l-2.877.285a6.983,6.983,0,0,0-2.137.57l-4.615,3.048A.422.422,0,0,1,18.564,32.944Z",
  transform: "translate(-18.231 -18.461)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3289.737 -6756.239)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.47,33.327a1.43,1.43,0,0,1-.342-.057l-1.054-.285a1.144,1.144,0,0,1-.028-2.222.325.325,0,0,1,.171.627c-.057.028-.427.142-.4.484a.591.591,0,0,0,.4.456l1.054.285a.643.643,0,0,0,.456-.057.441.441,0,0,0,.228-.313.518.518,0,0,0-.085-.4.327.327,0,0,1,.085-.456.356.356,0,0,1,.456.085,1.179,1.179,0,0,1,.2.912,1.03,1.03,0,0,1-.513.712A.857.857,0,0,1,30.47,33.327Z",
  transform: "translate(-28.187 -30.748)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3292.567 -6754.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.58,39.429a.3.3,0,0,1-.256-.142.321.321,0,0,1,.057-.456l3.39-2.507a.325.325,0,0,1,.4.513l-3.39,2.507A.259.259,0,0,1,18.58,39.429Z",
  transform: "translate(-18.253 -36.253)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3282.772 -6749.816)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.6,57.909a.257.257,0,0,1-.142-.028c-2.678-1.168-7.635-3.931-7.663-3.96a.323.323,0,0,1-.114-.456.3.3,0,0,1,.456-.114c.057.028,4.985,2.792,7.606,3.931a.336.336,0,0,1,.171.427A.362.362,0,0,1,60.6,57.909Z",
  transform: "translate(-52.636 -53.292)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3277.238 -6753.129)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.181,43.24a.213.213,0,0,1-.142-.028l-1.795-.94a.319.319,0,1,1,.285-.57l1.795.94a.307.307,0,0,1,.142.427A.313.313,0,0,1,74.181,43.24Z",
  transform: "translate(-72.062 -41.662)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3281.02 -6757.766)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.1,26.217a.293.293,0,0,1-.313-.285.3.3,0,0,1,.285-.342l2.251-.2a.315.315,0,1,1,.057.627l-2.251.2Z",
  transform: "translate(-58.787 -25.387)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3280.575 -6756.153)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.676,32.316a.305.305,0,0,1-.313-.256.324.324,0,0,1,.228-.4l2.422-.6a.325.325,0,0,1,.171.627l-2.422.6A.221.221,0,0,1,60.676,32.316Z",
  transform: "translate(-60.348 -31.048)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3279.887 -6754.611)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.086,38.239a.313.313,0,0,1-.285-.171.332.332,0,0,1,.142-.456l2.08-1.111a.338.338,0,1,1,.313.6l-2.08,1.111A.423.423,0,0,1,63.086,38.239Z",
  transform: "translate(-62.762 -36.462)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3294.93 -6752.962)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.284,52.207A.313.313,0,0,1,10,52.036a.349.349,0,0,1,.114-.456l2.222-1.2V43.119l-1.88.969a.319.319,0,0,1-.285-.57l2.365-1.225a.307.307,0,0,1,.313,0,.378.378,0,0,1,.171.285v8.005a.313.313,0,0,1-.171.285L10.455,52.15A.209.209,0,0,1,10.284,52.207Z",
  transform: "translate(-9.959 -42.25)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3297.785 -6752.813)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.268,56.086a.313.313,0,0,1-.285-.171A.335.335,0,0,1,.1,55.459L2.6,53.95a.357.357,0,0,0,.171-.313V43.808a.34.34,0,0,0-.2-.313.4.4,0,0,0-.37,0L.439,44.548a.365.365,0,0,1-.456-.114.332.332,0,0,1,.142-.456l1.766-1.054a.954.954,0,0,1,1.026,0,1.041,1.041,0,0,1,.513.883v9.828a1.081,1.081,0,0,1-.484.883L.467,56.029A.24.24,0,0,1,.268,56.086Z",
  transform: "translate(0.064 -42.775)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3275.147 -6752.962)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M82.078,52.178a.213.213,0,0,1-.142-.028L79.571,50.9a.313.313,0,0,1-.171-.285V42.578a.313.313,0,0,1,.171-.285.309.309,0,0,1,.313,0l2.365,1.225a.319.319,0,0,1-.285.57l-1.88-.969v7.293l2.194,1.168a.332.332,0,0,1,.142.456A.592.592,0,0,1,82.078,52.178Z",
  transform: "translate(-79.4 -42.25)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3272.754 -6752.802)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.962,56.112a.4.4,0,0,1-.171-.057l-2.507-1.51a1.014,1.014,0,0,1-.484-.883V43.834a1.026,1.026,0,0,1,1.538-.883L91.1,44a.332.332,0,0,1-.342.57L89,43.521a.333.333,0,0,0-.37,0,.382.382,0,0,0-.2.313v9.828a.327.327,0,0,0,.171.313l2.478,1.51a.349.349,0,0,1,.114.456A.239.239,0,0,1,90.962,56.112Z",
  transform: "translate(-87.8 -42.812)",
  fill: "#bdbdbd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3289.669 -6759.474)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.666,23.953a1.143,1.143,0,0,1-.427-.085l-.171-.028-1.909-.57H29.13a1.007,1.007,0,0,1-.6-.627,1.215,1.215,0,0,1,0-1,1.045,1.045,0,0,1,.627-.57,1.178,1.178,0,0,1-.057-.541,1.365,1.365,0,0,1,.484-.855,1.286,1.286,0,0,1,1.282-.2l2.621.883A1.244,1.244,0,0,1,33,22.785l-.114.313a1.345,1.345,0,0,1-.655.769A1.837,1.837,0,0,1,31.666,23.953Zm-2.308-1.31,2.08.627a.645.645,0,0,0,.513-.028.624.624,0,0,0,.342-.37l.085-.256-2.422-.769a1.118,1.118,0,0,1-.4-.228.527.527,0,0,0-.427.285.583.583,0,0,0,.028.484C29.216,22.5,29.273,22.614,29.358,22.642Zm2.678-.826.912.256a.613.613,0,0,0,.741-.4.622.622,0,0,0-.37-.741L30.7,20.05a.662.662,0,0,0-.912.541.616.616,0,0,0,.4.627Z",
  transform: "translate(-28.425 -19.392)",
  fill: "#bdbdbd"
}))));

var SvgApoio = function SvgApoio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApoio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apoio.fe42740b.svg";
export { ForwardRef as ReactComponent };